import { useRef } from 'react';

import { BALANCE_POLL_INTERVAL_MS, shouldPollBalance } from '../lib/balance-polling';
import { useGetLoyaltyBalance } from './useGetLoyaltyBalance';
import { useLoyaltyStore } from './useLoyaltyStore';

/**
 * Asks for the loyalty balance on the success screen until the purchase point
 * shows up, for 10 s at most (SWRN-2271).
 *
 * The baseline is read during the first render, before `LoyaltyLayout`'s fetch
 * starts in its effect — so it is the balance from the payment screen, the one
 * before this purchase. The full fetch on mount stays `LoyaltyLayout`'s; each
 * tick after it re-reads only the balance, on the same query key.
 */
export const useBalancePolling = (): void => {
    const baseline = useRef(useLoyaltyStore.getState().currentBalance);
    const startedAt = useRef(Date.now());

    useGetLoyaltyBalance({
        refreshBalanceOnly: true,
        refetchInterval: () => {
            const { currentBalance, isLoyaltyProgramActive } = useLoyaltyStore.getState();
            const isPolling = shouldPollBalance({
                baseline: baseline.current,
                current: currentBalance,
                elapsedMs: Date.now() - startedAt.current,
                isProgramActive: isLoyaltyProgramActive(),
            });
            return isPolling ? BALANCE_POLL_INTERVAL_MS : false;
        },
    });
};
